import React, {useState} from 'react'
import {CustomModal, TitleText} from '../../../common'
import {i18n} from '../../../../i18n'
import {Button, Table} from 'antd'
import {getOtherMedicationColumns} from '../../../../utils/medication_helper'
import {OtherPrescriptionDto} from '../../../../utils/types'
import {sharedStyles} from '../../../../style/shared_styles'
import {ButtonStyle} from '../../../../style/button'
import EditOtherMed from '../../actions/EditOtherMed'

/**
 * Component displaying the other medication data of a therapy plan.
 */
const OtherMedicationTable: React.FC<OtherMedicationTableProps> = props => {
    const [selectedMedId, setSelectedMedId] = useState('')
    const [modalVisible, setModalVisible] = useState(false)

    const dataSource = props.meds.map(item => ({key: item.id, ...item}))

    const onEditRow = (id: string) => {
        setSelectedMedId(id)
        setModalVisible(true)
    }

    const onNewItem = () => {
        setSelectedMedId('')
        setModalVisible(true)
    }
    return (
        <div style={{marginBottom: '2%'}}>
            <div style={{...sharedStyles.inlineContainer, marginTop: '2%'}}>
                <TitleText text={i18n.t('therapyTab.otherMedication.title')} />
                {props.actionsAvailable && (
                    <Button type={'default'} shape={'round'} style={ButtonStyle.primary} onClick={onNewItem}>
                        {i18n.t('button.create')}
                    </Button>
                )}
            </div>
            <Table
                dataSource={dataSource}
                columns={getOtherMedicationColumns(props.actionsAvailable && onEditRow)}
                pagination={false}
                rowClassName={'disable-hover'}
                locale={{ emptyText: i18n.t('therapyTab.otherMedication.noData') }}
            />
            <CustomModal title={i18n.t(`editMed.title.other.${selectedMedId ? 'edit' : 'new'}`)} open={modalVisible} width={'50%'}>
                <EditOtherMed otherMed={props.meds.find(med => med.id === selectedMedId)} onCloseModal={() => setModalVisible(false)} />
            </CustomModal>
        </div>
    )
}

type OtherMedicationTableProps = {
    meds: OtherPrescriptionDto[],
    actionsAvailable: boolean
}

export default OtherMedicationTable
